import React, { useCallback, useMemo, createContext, useContext } from "react";
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";
import { GrDrag } from "react-icons/gr";

const Context = createContext();

function Component1({ provided, children, Elem, item }) {
  const {
    dragStyle = {
      opacity: "0.5",
      position: "absolute",
      zIndex: "1",
      height: "100%",
    },
  } = useContext(Context);

  return (
    <div
      {...provided.draggableProps}
      {...provided.dragHandleProps}
      ref={provided.innerRef}
    >
      <div
        style={{
          position: "relative",
        }}
      >
        <GrDrag style={dragStyle} />
        <Elem data={item} />
      </div>
    </div>
  );
}

function DragAndDrop({
  list = [],
  onUpdateList,
  ItemToRender,
  ContainerToRender,
  onMyDragEnd = () => {},
  onMyDragStart = () => {},
  ...props
}) {
  const onDragEnd = (result) => {
    if (!result.destination) return;

    let elements = [...list];
    if (result.destination.index < result.source.index) {
      const recortado = elements.slice(
        result.destination.index,
        result.source.index
      );
      elements[result.destination.index] = elements[result.source.index];
      elements.splice(
        result.destination.index + 1,
        recortado.length,
        ...recortado
      );
      onUpdateList(elements);
    } else {
      const recortado = elements.slice(
        result.source.index + 1,
        result.destination.index + 1
      );
      elements[result.destination.index] = elements[result.source.index];
      elements.splice(result.source.index, recortado.length, ...recortado);
      onUpdateList(elements);
    }
    onMyDragEnd();
  };

  const myList = () => {
    return list.map((item) => item._id);
  };

  function Student({ student, idx }) {
    return (
      <Draggable draggableId={`draggable${idx}`} index={idx}>
        {(provided) => {
          return (
            <Component1
              Elem={ItemToRender}
              provided={provided}
              item={list.find((item) => item._id === student)}
            />
          );
        }}
      </Draggable>
    );
  }

  function InnerList(props) {
    return props.list.map((item, idx) => (
      <Student key={idx} idx={idx} student={item} />
    ));
  }

  const provided = useCallback(
    (provided) => (
      <ContainerToRender ref={provided.innerRef} {...provided.droppableProps}>
        <InnerList list={list.map((item) => item._id)} />
        {/* {list.map((item, idx) => (
          <Draggable draggableId={`draggable${idx}`} index={idx}>
            {(provided2) => {
              console.log('atualizando..');
              return (
                <Component1
                  Elem={ItemToRender}
                  provided={provided2}
                  item={item}
                />
              );
            }}
          </Draggable>
        ))} */}
        {provided.placeholder}
      </ContainerToRender>
    ),
    [myList]
  );

  return (
    <div {...props}>
      <Context.Provider value={props}>
        <DragDropContext
          onBeforeDragStart={onMyDragStart}
          onDragEnd={onDragEnd}
        >
          <Droppable droppableId={"1"}>{provided}</Droppable>
        </DragDropContext>
      </Context.Provider>
    </div>
  );
}

export default DragAndDrop;
